<template>
  <AiChatCard
    :companyId="companyId"
    endpoint="/api/eac/buy-and-cancel/chat"
    :title="$t('bulk_buy.accelerator_title')"
    :greeting="$t('ai_chat.greetings.bulk_buy')"
    @analysis-complete="$emit('analysis-complete', $event)"
  />
</template>

<script setup lang="ts">
import AiChatCard from "../common/AiChatCard.vue";

defineProps<{
  companyId: number;
}>();

defineEmits<{
  "analysis-complete": [data: any];
}>();
</script>
